import * as React from 'react'
import {
  Toaster,
  useToastController,
  ToastTitle,
  Toast as FUIToast
} from '@fluentui/react-components'

export enum ToastIntentEnum {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error'
}

interface ToastProps {
  triggerToast: ToastIntentEnum
  title: string
}

const Toast: React.FC<ToastProps> = ({ triggerToast, title }) => {
  const { dispatchToast } = useToastController()

  React.useEffect(() => {
    if (triggerToast) {
      dispatchToast(
        <FUIToast>
          <ToastTitle>{title}</ToastTitle>
        </FUIToast>
      )
    }
  }, [triggerToast, title, dispatchToast])

  return <Toaster />
}

export default Toast
